import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14662 22365"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M423 16581c-285-661-495-5249 5-5748 316-316 1458 86 1762 651 513 955 122 1751 515 2787 377 994 1015 769 1330-311 0 0 75-1328-27-1755-171-717-1297-5505-1807-7733-449-1965 881-2725 1301-2236 895 1043 3215 9343 3215 9343l-409-2355c0-845 2195-428 2461 159l630 2196s-251-1446-251-2090c0-359 1677 30 2108 622 295 406 825 1468 825 1468s-414-1323-358-1409c128-199 1491 495 1934 1146 1432 2110 1022 4477 655 7027-263 1828-1248 3101-1785 3676-207 221-495 346-798 346H6121c-281 0-532-129-753-300-2135-1658-3907-3076-4945-5484z"
        className="fil0"
      />
      <path
        d="M677 3158c0-1368 1113-2481 2481-2481s2481 1113 2481 2481c0 643-248 1228-650 1669 80 230 161 466 242 707 663-579 1085-1428 1085-2376C6316 1417 4899 0 3158 0S0 1417 0 3158c0 1425 950 2631 2248 3023-64-279-126-547-185-800-820-405-1386-1248-1386-2223z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
